import { SocialPlatforms } from "../../components/campaign/types";

export enum FailedPostStatus {
    Error = "ERROR",
    Retrying = "RETRYING",
    // MB-1683: waiting for the writer (Claude unreachable); its own task retries with backoff.
    PendingRegeneration = "PENDING_REGENERATION",
}

export interface FailedPostOwner {
    userId: string;
    name: string;
    email: string;
}

export interface FailedPost {
    postId: string;
    owner: FailedPostOwner;
    listingLabel: string;
    // Optional: posts that errored before MB-1330 won't carry these.
    campaignId?: string;
    // "N/A" when the API can't resolve a platform (p.platform?.name ?? "N/A"); display-only.
    platform: SocialPlatforms | "N/A";
    status: FailedPostStatus;
    retryCount: number;
    // MB-1683: attempts so far and when the next try is due, on a post waiting for the writer.
    regenerationAttempts?: number;
    nextRegenerationAt?: string;
    lastFailureReason?: string;
    lastFailedAt?: string;
    scheduledFor?: string;
}

// Platform options for the admin platform filter — derived from the canonical SocialPlatforms enum.
export const FAILED_POST_PLATFORMS: string[] = Object.values(SocialPlatforms);

export interface PaginatedFailedPosts {
    items: FailedPost[];
    total: number;
    page: number;
    limit: number;
}

export interface RescheduleResult {
    postId: string;
    ok: boolean;
    error?: string;
}

export type FailedPostSortColumn =
    | "platform"
    | "status"
    | "retryCount"
    | "lastFailedAt"
    | "scheduledFor";

export type SortDirection = "asc" | "desc";

export type { AppConfigDataType, AppConfigItem } from "../app-config/types";

// Machine key for the post-retry config group — passed to GET /app-config?group=.
export const POST_RETRY_CONFIG_GROUP = "POST_RETRY";

// Config keys within the POST_RETRY group. The retry-settings UI keeps these two in lockstep:
// one editable row per retry, so max_retries is always backoff_minutes.length.
export const POST_RETRY_MAX_RETRIES_KEY = "post_retry.max_retries";
export const POST_RETRY_BACKOFF_MINUTES_KEY = "post_retry.backoff_minutes";
